import { useGlobalContext } from 'hooks';

const useObjOrTestator = obj => {
  const { testator } = useGlobalContext();

  return obj || testator;
};

export default useObjOrTestator;
